<style lang="scss" scoped>
.frame-head-container {
  height: 102px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  gap: 24px;
  .agent-name {
    span {
      font-weight: bold;
      font-size: 36px;
      color: var(--izt-head-text-color-85);
    }
  }
  .background-image {
    width: 227px;
    height: 58px;
    background-image: var(--izt-logo-img);
    background-repeat: no-repeat;
    background-position: left;
    background-size: contain;
  }
}
.mini-program {
  height: 122px !important;
}
</style>

<template>
  <!-- 取消小程序的样式，因小程序在webview下  无法隐藏顶部导航栏 -->
  <!-- , $isWxMiniRes ? 'mini-program' : '' -->
  <div :class="['frame-head-container']">
    <div class="agent-name">
      <span>{{ configStore.AgentName }}</span>
    </div>
  </div>
</template>

<script setup name="frame-head">
  import { useConfigStore } from '@/stores/modules/config'
  defineOptions({ name: 'frame-head' })

  const configStore = useConfigStore()
</script>